console.log('custom-media-fix.js geladen ✓');

function fixMediaGallery() {
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const allSlides = gallery.querySelectorAll('li[data-media-id]');
  if (allSlides.length < 2) return;

  const firstRealMedia = allSlides[1];
  const mediaId = firstRealMedia.dataset.mediaId;
  console.log('Setze aktives Bild auf:', mediaId);

  if (gallery.setActiveMedia) {
    gallery.setActiveMedia(mediaId, false);
  }

  // Slider-Position zurücksetzen
  const slider = gallery.querySelector('slider-component');
  if (slider && slider.resetPages) {
    slider.resetPages();
  }

  // Scroll zum zweiten Element
  const ul = gallery.querySelector('ul[id^="Slider-Gallery"]');
  if (ul) {
    ul.scrollTo({ left: firstRealMedia.offsetLeft, behavior: 'instant' });
  }
}

setTimeout(fixMediaGallery, 300);
setTimeout(fixMediaGallery, 900);
